// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2WBVI","main-image":"Header_main-image__OmKhx"};